import React, { Component } from 'react';
import { Link, withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import Pagination from "react-js-pagination";
import $ from 'jquery';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap"; 

import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { apiUrl} from'../Config/Config';
import axios from 'axios';
import 'react-confirm-alert/src/react-confirm-alert.css'; 

class List extends Component {
  constructor(props)
  {
    super(props);
    this.state = {
      visitreason:'',
      domainlist:[],
      confirmDelete:'',
      totalRecord:0,
      selectid:"",
      selectedStatus:""
    };
    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidMount() {
      var qs = require('qs');
      var admin_id = localStorage.getItem("admin_id");
      var loggedas = localStorage.getItem("loggedas");
      var postobject = {
      activePage: 1,
      search_all: '',
      admin_id: admin_id,
      loggedas: loggedas
      };  

      axios.post(apiUrl+"VisitReasonManagement/list",qs.stringify(postobject)).then(res => {
        if(res.data.status === 'success'){
         
            this.setState({  visitreason: res.data.visitreason, totalRecord: res.data.records_count}, function() {
            
              this.visitreason();
            });
  
        }
      }); 
   }

   handlePageChange(pageNumber) {
    // console.log(`active page is ${pageNumber}`);
     this.setState({activePage: pageNumber});

     var qs = require('qs');

     var admin_id = localStorage.getItem("admin_id");
     var loggedas = localStorage.getItem("loggedas");
     var postobject = {
       activePage: pageNumber,
       search_all: this.state.search_all,
       admin_id: admin_id,
       loggedas:loggedas
     };
    //  this.props.getvisitreason(qs.stringify(postobject))
    axios.post(apiUrl+"VisitReasonManagement/list",qs.stringify(postobject)).then(res => {
      
      if(res.data.status === 'success'){
          this.setState({  visitreason: res.data.visitreason, totalRecord: res.data.records_count}, function() {
            this.visitreason();
          });

      }
    }); 

   }

   handleInputChange(event) {
   const {name, value} = event.target;      
   this.setState({
     [name]: value
   });
   
 }

 handleFormSubmit = () => {
        
  this.setState({Loading:true});
  var qs = require('qs');
  const formPayload = this.state;
   var admin_id = localStorage.getItem("admin_id");
   var loggedas = localStorage.getItem("loggedas");
  var postObject = {             
    activePage   : 1,
    search_all : formPayload.search_all,
    admin_id: admin_id,
    loggedas: loggedas         
  };
  axios.post(apiUrl+"VisitReasonManagement/list",qs.stringify(postObject)).then(res => {
    if(res.data.status === 'success'){

        this.setState({  visitreason: res.data.visitreason, totalRecord: res.data.records_count}, function() {
          this.visitreason();
        });

    }else{
      this.setState({  visitreason:'', totalRecord: ''}, function() {
        this.visitreason();
      });
    }
  }); 

} 



deleteConfirm=(confirmstatus,id)=>{
  if(confirmstatus == 'yes'){
    $('.confirm-action-delete').removeClass('show');
    var qs = require('qs');

    var postObject = {
      admin_id : localStorage.getItem("admin_id"),
      id :this.state.confirmDelete,
    };
    axios.post(apiUrl+"VisitReasonManagement/delete",qs.stringify(postObject)).then(res => {
      if(res.data.status === 'success'){       
            window.location.reload(); 
      }
    });
  }else{
    $('.confirm-action-delete').removeClass('show');	
  }
}  
deleteabusive(id){
  this.setState({confirmDelete : id})
  $('.confirm-action-delete-message').html('Are you sure delete the  Visit reason?');	
  $('.confirm-action-delete').addClass('show');	
 }
activatevisitreason(){
  let stat = ''
    if(this.state.selectedStatus == 'Inactive'){
      stat = "I";
    }else{
      stat = "A";
    }
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :this.state.selectid,
          status: stat
        };

      axios.post(apiUrl+"VisitReasonManagement/change_status",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
           window.location.reload(false);
        }
      }); 
}
confirmPopup = (id, status,cat_title) => {
  var status = status;
  console.log(status,'this is  status')
  if(status == 'Inactive'){
    status = "Active";
  }else if(status == 'Active'){
    status = "Inactive";
  }
 
  this.setState({selectid: id, selectedStatus: status,cat_title:cat_title})	
  $('.confirm-action').addClass('show');		
}

visitreason() {
  let catImg = '';
  let preview = '';
    var visitreason = this.state.visitreason;
    if (visitreason != "undefined" && visitreason != null) {
    
      if (visitreason.length > 0) {

        if (Object.keys(visitreason).length > 0) {
          const helperlistDetails = visitreason.map(
            (visitreason, Index) => {
              let sno = Index+1;
              

               if(visitreason.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }
             
              return (
                <tr key={visitreason.id}>
      					<td>{sno}</td>
      					<td>{visitreason.reason}</td>
                
                <td>{status}</td>
                <td className="actiongroup" >
                    
                    
                    <Link to={{ pathname: '/visitreason-edit/'+visitreason.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                    {(status == 'Active'?<Link onClick={this.confirmPopup.bind(this, visitreason.id, status)} className="" title="Status"><i className="ft-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.confirmPopup.bind(this, visitreason.id, status)} className="" title="Status"><i className="ft-lock" aria-hidden="true"></i></Link>)} 


                    {/* <Link to={{ pathname: '/visitreason-edit/'+visitreason.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                    {(status == 'Active'?<Link onClick={this.activateabusive.bind(this, visitreason.id, status)} className="" title="Status"><i className="ft-unlock" aria-hidden="true"></i></Link>:<Link onClick={this.activateabusive.bind(this, visitreason.id, status)} className="" title="Status"><i className="ft-lock" aria-hidden="true"></i></Link>)}            */}

                    
                     <Link onClick={this.deleteabusive.bind(this,visitreason.id)} className="" title="Duplicate"><i class="ft-trash-2" aria-hidden="true"></i></Link>
                    
                  </td>
                </tr>
              );
            }
          );
          return helperlistDetails;
        }
      } else {
        return (
          <tr>
            <td colspan="11" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }else {
      return (
        <tr>
          <td colspan="11" className="v-align-nr">
            No Result
          </td>
        </tr>
      );
    }
  }
  
Confirmstatus = (confirmstatus) => {
  if(confirmstatus == 'yes'){
   
      this.activatevisitreason();
    $('.confirm-action').removeClass('show');
  }else{
    $('.confirm-action').removeClass('show');	
  }
    
}

  render() {

    const {domainlist,universitynamelist} = this.state;
	  var current = this;
    var admin_id = localStorage.getItem('admin_id');
   let catImg = '';
  let preview = '';
    return (
      <div className="wrapper"> 
   
    <div className="confirm-action">
			<p>Are you sure you want to {this.state.selectedStatus} Visit reason"?</p>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "yes")} className="btn">Yes</a>
			<a href="javascript://" onClick={this.Confirmstatus.bind(this, "no")} className="btn">No</a>
		</div>
    <Header />
    <MenuSidebar currentpage="visitreason" /> 
      <div className="content"> 
        <div className="content-wrapper">
        <div class="content-wrapper-before"></div>
   
         <div className="car-listing-wrap leaa-admin-head card vi-2">
            <div className="success_message"></div>
              <div className="listing-header">
                <div className="title">
                  <h3>{(this.state.totalRecord>0&&this.state.totalRecord!='')&&this.state.totalRecord} Visit Reasons</h3>
                </div>
               

                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >     
                    <div className="search-inner">
                      <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" /> 
                     <button className="" type="submit">Submit</button>
                    <div className="erroremail"></div>
                  </div>
                 </form>
                </div>
                 <div className="add_button">  
                    <a className="" href='/visitreason-add'>Add</a>
                </div>
                </div>      
                         
              <div style={{color:"green", fontSize: 30}} className="statusmessage"></div>
            
              <div className="car-listing-row table-avrech">
              <div className="overflow">
                <Table striped bordered hover>
                  <thead>
                  <tr>
                  <th>S.No</th>
			            <th>Viste Reason</th>
                 
                  <th>Status</th>
                  <th style={{width:"100px"}}>Action</th>
                   </tr>
                  </thead>
                  <tbody>{this.visitreason()}</tbody>
                </Table>
			        	</div>
                <div className="text-center">
                  <Pagination
                  activePage={this.state.activePage}
                  itemsCountPerPage={10}
                  totalItemsCount={this.state.totalRecord}
                  pageRangeDisplayed={5}
                  onChange={this.handlePageChange.bind(this)}
                  />
                </div>
              </div>

            </div> 
        </div>  
      </div>
      <div className="confirm-action-delete">
								<p className="confirm-action-delete-message"></p>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "yes",this.state.abus_id)} className="btn">Yes</a>
								<a href="javascript://" onClick={this.deleteConfirm.bind(this, "No")} className="btn">No</a>
								<span class="close-support" onClick={this.deleteConfirm.bind(this, "No")}  >X</span>
				</div>
    </div>
    );
  }
}
export default (withRouter(List));